<template>
  <div class="tab-body">
    <div class="search">
      <el-form ref="form" :model="searchParams" label-width="80px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="部门:" v-if="dpts">
              <el-select
                v-model="searchParams.dept"
                @change="search(3)"
                placeholder="请选择部门"
              >
                <el-option
                  v-for="item in dpts"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
           <el-col :span="6" class="box">
            <el-form-item label="状态" v-if="dpts">
              <el-select v-model="state" @change="search">
                <el-option
                  v-for="item in [
                    { label: '全部状态', value: '3' },
                    { label: '待审', value: '0' },
                    { label: '通过', value: '1' },
                    { label: '需修改', value: '2' },
                  ]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
                </el-col>
          <el-col :span="6" class="box">
            <div class="box2">
              <el-button  type="primary" size="mini" @click="search(-11)" v-if="navi.prev">
                《《
              </el-button>
              <el-date-picker
                v-model="month"
                type="month"
                placeholder="选择月"
                value-format="yyyy-MM"
                @change="search(1)"
              >
              </el-date-picker>

              <el-button  type="primary" size="mini" @click="search(11)" v-if="navi.next"
                >》》</el-button
              >
            </div>
          </el-col>

  <el-col :span="5" class="box">
 	    <el-button @click="clearSearchVal">清空</el-button>
 </el-col>
        </el-row>
      </el-form>
    </div> 
    <div class="operator">
       <el-button
        type="warning"
        icon="el-icon-plus"
        @click="toSave('填写上周周报')"
        >填写上周周报</el-button
      >
      <el-button
        type="success"
        icon="el-icon-plus"
        @click="toSave('填写本周周报')"
        >填写本周周报</el-button >
    </div>
    <div class="dataTable autoFlex" v-if="listData">
      <qlh-table
        class="table"
        :data="listData.records"
        stripe
        height="auto"
        @selection-change="selectionChange"
        v-loading="listLoading"
      >
        <qlh-table-column type="index" label="序号"></qlh-table-column>
        <qlh-table-column
          prop="sqlMapper_empid"
          label="填报人"
        ></qlh-table-column>
        <qlh-table-column prop="time" label="周报日期">
          <template slot-scope="scope" v-if="scope.row">
            {{ scope.row.wrptstartday }}&nbsp;&nbsp;~&nbsp;&nbsp;
            {{ scope.row.wrptendday }}
          </template>
        </qlh-table-column>
        <qlh-table-column prop="statestr" label="状态">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.state == 1">已审批</el-tag>
            <el-tag type="warning" v-if="scope.row.state == 0">待审批</el-tag>
            <el-tag type="danger" v-if="scope.row.state == 2">需修改</el-tag>
          </template>
        </qlh-table-column>
        <qlh-table-column prop="sper" label="审批">
            <template slot-scope="scope">
                <el-tag type="success"  v-if="scope.row.sptm">{{scope.row.sptm}}</el-tag>
                <el-tag type="success"  v-if="scope.row.sper">{{scope.row.sper}}</el-tag>
          </template>
        </qlh-table-column>
       <qlh-table-column prop="sptxt" label="审批意见"> </qlh-table-column>
        <qlh-table-column label="操作" fixed="right" width="400px" ignored>
          <template slot-scope="scope" v-if="scope.row">
            <div class="dataTable-operator">
              <el-button
                size="mini"
                icon="el-icon-search"
                @click="toDetail(scope.$index, scope.row)"
                >  {{(scope.row.state==0 && (  me.role2=='admin'||  me.role2=='admin2'|| me.role2=='mgr'||  me.role2=='mgr2'||  me.role2=='mgr3')) ? '审批': '详情'   }}   </el-button
              >
              <el-button
                size="mini"
                icon="el-icon-edit"
                v-if="isCanOpt(scope.row)"
                @click="toUpdate(scope.$index, scope.row)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                icon="el-icon-delete"
                type="danger"
                v-if="isCanOpt(scope.row)"
                @click="remove(scope.$index, scope.row)"
                >删除</el-button
              >
            </div>
          </template>
        </qlh-table-column>
      </qlh-table>
      <div class="pageBar">
        <el-pagination
          @size-change="sizeChange"
          @current-change="currentChange"
          :total="listData.total"
          :page-size="page.size"
          :current-page="page.current"
          :layout="this.$constant.page.layout"
          :page-sizes="this.$constant.page.pageSizes"
        ></el-pagination>
      </div>
    </div>
    <edit ref="edit" @flush="list()"></edit>
  </div>
</template>
<script>
import edit from "./edit.vue";
import qlhTable from "@/components/qlhTable/qlhTable.vue";
import qlhTableColumn from "@/components/qlhTable/qlhTableColumn.vue";
import api from "@/api/oa/wkreport.js";
import selectOptionDictionary from "@/components/biz/selectOptionDictionary/selectOptionDictionary.vue";
export default {
  name: "wkreport",
  components: {
    edit,
    qlhTable,
    qlhTableColumn,
    selectOptionDictionary,
  },
  data() {
    return {
      formLabelWidth: "120px",
      searchParams: {},
      state: "3",
      isShowMoreSearch: false,
      listLoading: false,
      listData: [],
      dpts: undefined,
      month: "",
      selected: [],
      page: new this.$constant.pageObj(),
      me: {},
      spAdv: {},
      navi: {},
    };
  },
  methods: {
 
    isCanOpt(row) {
      //判断能否操作  删除和编辑
      if (row.state == 0 || row.state == 2) {
        if (row.empid == this.me.id) {
          return true;
        }
      }
      return false;
    },
    //获取数据
    list() {
      this.listLoading = true;

      if (this.month && Date == typeof this.month) {
        this.searchParams.month = this.month.format("yyyy-MM");
      }

      let params = this.$utils.merger(this.searchParams, this.page);
      if (this.state != 3) {
        params.state = this.state;
      }

      api.list(params, (response) => {
        // 总经理
        if (response.data.dpts) {
          this.dpts = response.data.dpts;
        }
        this.listData = response.data.datas;
        // 可以导航的月份
        this.navi = response.data.navi;
        // 解析时间
        this.month = new Date(this.navi.crnt.replaceAll("-", "/") + "/01");

        this.listLoading = false;
      });
    },
    //去添加
    toSave(txt) {
      this.$refs.edit.open({}, this.me,3, txt);
    },
    //去编辑
    toUpdate(index, row) {
      this.$refs.edit.open(row, this.me,2, "编辑 " + row.sqlMapper_empid + "["+row.wrptstartday+" ~ "+row.wrptendday+"]的周报");
    },
    //去详情
    toDetail(index, row) {
      this.$refs.edit.open(
        row,
        this.me,1,
        row.sqlMapper_empid + "["+row.wrptstartday+" ~ "+row.wrptendday+"]的周报详情",
        true
      );
    },
    //删除
    remove(index, row) {
      this.$utils.confirm.warning("提示", "确定删除吗？", () => {
        api.remove(
          { ids: row.id },
          (response) => {
            this.$utils.msg.success(response.msg);
            this.list();
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
          }
        );
      });
    },

    //改变选择项
    selectionChange(val) {
      //清空
      this.selected = [];
      for (let item of val) {
        this.selected.push(item.id);
      }
    },
    //改变每页显示数量
    sizeChange(val) {
      this.page.size = val;
      this.list();
    },
    //改变现在的页码
    currentChange(val) {
      this.page.current = val;
      this.list();
    },
    //搜索
    search(type) {
      if (type) {
        if (type == -11) {
          //上1月
          this.searchParams.month = this.navi.prev;
        } else if (type == 11) {
          //下1月
          this.searchParams.month = this.navi.next;
        } else if (type == 1) {
          // 时间选择器
          this.searchParams.month = this.month;
        } else if (type == 3) {
          // 部门选择器

        }  
      }
      this.list();
    },
    clearSearchVal() {
      this.searchParams = {};
      this.state = "3";
      this.month=""
      this.list();
    },
  },
  mounted() {
    // 前端取回自己
    this.me = this.$caches.user.get();
    //总经理
    if ("admin" == this.me.role2||"admin2" == this.me.role2) {
      this.searchParams = { dept: "靖凯开源"};
      //部门经理
    } 

    this.list();
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
.box {
  display: flex;
}
.box2 {
  display: flex;
  margin: 0px 10PX;
}
</style>
